import { useQuery } from "@tanstack/react-query";
import { ageDistributionAnalytics, monthWiseAnalytics, statsAnalytics } from "../api/analyticsApi";

export const useAnalyticsHook = () => {
  const handleStatsAnalytics = useQuery({
    queryKey: ['stats-analytics'],
    queryFn: statsAnalytics,
    refetchOnWindowFocus: false,
  });

  const handleMonthWiseAnalytics = useQuery({
    queryKey: ['month-wise-analytics'],
    queryFn: monthWiseAnalytics,
    refetchOnWindowFocus: false,
  });

  const handleAgeDistributionAnalytics = useQuery({
    queryKey: ['age-distribution-analytics'],
    queryFn: ageDistributionAnalytics,
    refetchOnWindowFocus: false,
  });

  return {
    handleStatsAnalytics,
    handleMonthWiseAnalytics,
    handleAgeDistributionAnalytics,
  };
};